import { Box, styled } from "@mui/material"
import { colors } from "../../../../styles/commonStyles"

export const ViewOpportunityButtonWrapper: any = styled(Box)({
  height: "40px",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px",
  borderRadius: "4px",

  backgroundColor: colors.primaryOrange,
  "&:hover": {
    backgroundColor: colors.primaryOrange,
  },
  "&:disabled": {
    color: "#FFFFFF",
    backgroundColor: "#707070",
  },
})
